import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/Main.vue";
import Home from "@/components/Home.vue";
import publicRoutes from "./public";
import { verifyToken, trackPage, conditionalRoute } from "./navigation-guard";
import patientRoutes from "./patient";
import dashboardRoutes from "./dashboard";
import dashboardAlertsRoutes from "./followups";
import treatmentRoutes from "./treatment";
import userRoutes from "./user";
import profileRoutes from "./profile";
import indicationRoutes from "./indication";
import appointmentRoutes from "./appointment";
import settingsRoutes from "./settings";
import paymentRoutes from "./payment";
import validationRoutes from "./validation";
import prescriptionRoutes from "./prescription";
import contractsRoutes from "./contracts";
import administrationRoutes from "./administration";
import ordersCrmRoutes from "./orders-crm";
import statsRoutes from "./stats";
import doctorRoutes from "./doctor";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "is-active",
  routes: [
    ...publicRoutes,
    {
      path: "/",
      component: Main,
      children: [
        {
          path: "/",
          name: "home",
          component: Home,
        },
        ...dashboardAlertsRoutes,
        ...dashboardRoutes,
        ...patientRoutes,
        ...treatmentRoutes,
        ...userRoutes,
        ...profileRoutes,
        ...indicationRoutes,
        ...appointmentRoutes,
        ...settingsRoutes,
        ...paymentRoutes,
        ...validationRoutes,
        ...prescriptionRoutes,
        ...contractsRoutes,
        ...administrationRoutes,
        ...ordersCrmRoutes,
        ...statsRoutes,
        ...doctorRoutes,
      ],
    },
  ],
});

router.beforeEach(verifyToken);
router.beforeEach(trackPage);
router.beforeEach(conditionalRoute);

export default router;
